import MenuIcon from '@mui/icons-material/Menu';
import { Grid, IconButton, useMediaQuery, useTheme, Menu, Tooltip } from '@mui/material';
import { MessageList, Chat } from 'components/organisms';
import React, { useEffect, useState } from 'react';

export const MessageTemplate = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [menuOpen, setMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [correspondentId, setCorrespondentId] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (!isSmallScreen) {
      setMenuOpen(false);
      setAnchorEl(null);
    }
  }, [isSmallScreen]);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleClose = () => {
    setMenuOpen(false);
    setAnchorEl(null);
  };

  return (
    <>
      {isSmallScreen ? (
        <>
          <Tooltip title="View Messages" placement="right">
            <IconButton
              onClick={handleOpen}
              sx={{
                // @ts-ignore
                backgroundColor: theme.palette.grey.light,
                height: '40px',
                width: '40px',
              }}
            >
              <MenuIcon />
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            open={menuOpen}
            onClose={handleClose}
            sx={{ maxHeight: '40vh', minHeight: '40vh', maxWidth: '40vh', padding: 0 }}
            MenuListProps={{
              disablePadding: true,
            }}
          >
            <MessageList isMenu={true} onClick={setCorrespondentId} />
          </Menu>
        </>
      ) : null}
      <Grid container spacing={5} sx={{ height: '100%' }}>
        {!isSmallScreen ? (
          <Grid item md={4} sx={{ height: '95%' }}>
            <MessageList onClick={setCorrespondentId} />
          </Grid>
        ) : null}
        <Chat correspondentId={correspondentId} />
      </Grid>
    </>
  );
};
